import * as React from 'react';
import styled from 'styled-components';

import { Button } from 'components/bootstrap';
import { SelectedRowsProvider } from 'common/contexts';
import { Modal } from 'common/components';
import { Row, Col } from 'security-app/components/common/FormBaseStyles';
import { useListGitRepos } from 'security-app/hooks/useSigmaAPI';
import type { GitRepoAPIModel } from 'security-app/hooks/api/sigmaAPI.types';
import EntityCreateShareFormGroup from 'components/permissions/EntityCreateShareFormGroup';
import type { EntitySharePayload } from 'actions/permissions/EntityShareActions';

import { Window } from './styledComponents';
import LeftPanel from './LeftPanel';
import RightPanel from './RightPanel';
import ImportErrorsAlert from './ImportErrorsAlert';

type ButtonsProps = {
  onCancel: () => void;
  importDisabled: boolean;
  setImportRules: (arg: boolean) => void;
};
const StyledDiv = styled.div`
  display: block;
`;
const Buttons = ({ onCancel, importDisabled, setImportRules }: ButtonsProps) => (
  <Row $width="100%" $gap="0.5rem" $justify="flex-end" $align="center">
    <Button type="reset" form="ruleOptions" onClick={onCancel}>
      Cancel
    </Button>
    <Button bsStyle="primary" disabled={importDisabled} onClick={() => setImportRules(true)}>
      Import rules
    </Button>
  </Row>
);

function GitRulesModal({ onClose }: { onClose: () => void }) {
  const [shareRequest, setShareRequest] = React.useState<EntitySharePayload>(null);
  const [importRules, setImportRules] = React.useState<boolean>(false);
  const [importErrors, setImportErrors] = React.useState<string[]>([]);
  const [repo, setRepo] = React.useState<GitRepoAPIModel>(null);
  const { repos, loadingRepos } = useListGitRepos({ page: 1, perPage: 10000 });

  return (
    <Modal
      show
      onClose={onClose}
      title={
        <div>
          Viewing: <small>{repo?.name || ''}</small>
        </div>
      }
      maxWidth="1200px"
      buttons={
        <Buttons
          onCancel={onClose}
          importDisabled={importRules || importErrors.length > 0}
          setImportRules={setImportRules}
        />
      }>
      <Col $width="100%">
        <SelectedRowsProvider>
          <Row $width="100%" $align="stretch" $justify="stretch">
            <Window data-testid="navigator" $width={45}>
              <LeftPanel repo={repo} setRepo={setRepo} repos={repos} loadingRepos={loadingRepos} />
            </Window>
            <Window data-testid="selection" $width={65}>
              <RightPanel
                importRules={importRules}
                setImportRules={setImportRules}
                setImportErrors={setImportErrors}
                closeModal={onClose}
                shareRequest={shareRequest}
              />
            </Window>
          </Row>
        </SelectedRowsProvider>
        {importErrors.length > 0 && <ImportErrorsAlert importErrors={importErrors} setImportErrors={setImportErrors} />}
      </Col>
      <StyledDiv>
        <EntityCreateShareFormGroup
          description="Search for a User or Team to add as collaborator on this sigma rule."
          entityType="sigma_rule"
          onSetEntityShare={(payload) => setShareRequest(payload)}
        />
      </StyledDiv>
    </Modal>
  );
}

export default GitRulesModal;
